// extracted by mini-css-extract-plugin
module.exports = {"RulesTab":"RulesTab_RulesTab__gQzGw"};